export default "__VITE_ASSET__C22lRgSH__"